import { useCallback, useState } from "react";

/**
 * Tracks an element's rendered height. Returns a callback ref to attach and
 * the latest height in px (0 until measured, and where ResizeObserver is
 * unavailable).
 */
export function useElementHeight<T extends HTMLElement>(): [
  (node: T | null) => void,
  number,
] {
  const [height, setHeight] = useState(0);
  const [observer] = useState(() =>
    typeof ResizeObserver === "undefined"
      ? null
      : new ResizeObserver(([entry]) => {
          // Border box, so padded toolbars report their full height
          if (entry) {
            setHeight(Math.round(entry.target.getBoundingClientRect().height));
          }
        }),
  );
  const ref = useCallback(
    (node: T | null) => {
      observer?.disconnect();
      if (!node) return;
      setHeight(Math.round(node.getBoundingClientRect().height));
      observer?.observe(node);
    },
    [observer],
  );
  return [ref, height];
}
